import CRUDService from "../services/base/CRUDService";

export default class DispositionService extends CRUDService {

  static ALL_URL = 'ton/v1/dispositions';

  getBaseURL() {
    return "ton/v1/dispositions/";
  }

}



// WEBPACK FOOTER //
// ./src/disposition/DipositionService.js